import { render } from "./ArticleSingle.vue?vue&type=template&id=5b855baa"
import script from "./ArticleSingle.vue?vue&type=script&lang=js"
export * from "./ArticleSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/ArticleSingle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b855baa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b855baa', __exports__)) {
    api.reload('5b855baa', __exports__)
  }
  
  module.hot.accept("./ArticleSingle.vue?vue&type=template&id=5b855baa", () => {
    api.rerender('5b855baa', render)
  })

}


export default __exports__